<template>
  <div>
    <main-cpn :contract-info="contractInfo"
              @setCustomRewardToken="setCustomRewardToken"
              @revertToBNBReward="revertToBNBReward"
              @claimReward="claimReward"
              :loading-data="loadingData"/>
  </div>
</template>
<script>

import MainCpn from "./components/MainCPN";
import {mapGetters} from 'vuex'
import WalletConnectWrap from '@/components/Mixins/WalletConnectWrap'

import {
  getContractInfo,
  getDogeKongZillaBalance,
  setRewardTokenCustom,
  revertBNBToKenReward,
  claimReward
} from '@/libs/dogekongzilla'

export default {
  name: "components",
  mixins: [WalletConnectWrap],
  data() {
    return {
      loadingData: false,
      contractInfo: {},
      chainId: 0,
      dkzBalance: 0,
      priceFeedData: {
        RAW: {
          BNB: {
            USD: {
              PRICE: 0
            }
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters([
      'connected_wallet'
    ]),
  },
  components: {
    MainCpn,
  },
  methods: {
    async claimReward() {
      let v = this
      try {
        this.loadingData = true
        await claimReward(this.walletClient.web3Client)
        this.loadingData = false

        v.$swal.fire({
          icon: 'success',
          title: 'Claim successfully!',
          text: 'You have successfully claimed the reward, congratulations!',
        })

      } catch (error) {
        console.error(error);
        v.loadingData = false
        v.$swal.fire({
          icon: 'error',
          title: 'Have some problem here!',
          text: error,
        })
      }
    },

    async revertToBNBReward() {
      let v = this
      try {
        this.loadingData = true
        await revertBNBToKenReward(this.walletClient.web3Client)
        this.loadingData = false

        v.$swal.fire({
          icon: 'success',
          title: 'Revert successfully!',
          text: 'You have successfully reverted reward token to BNB , congratulations!',
        })

      } catch (error) {
        console.error(error);
        v.loadingData = false
        v.$swal.fire({
          icon: 'error',
          title: 'Have some problem here!',
          text: error,
        })
      }

    },

    async setCustomRewardToken(token) {

      let v = this
      try {
        this.loadingData = true
        await setRewardTokenCustom(this.walletClient.web3Client, token)
        this.loadingData = false

        v.$swal.fire({
          icon: 'success',
          title: 'Set successfully!',
          text: 'You have successfully customized reward token to BNB , congratulations!',
        })

      } catch (error) {
        console.error(error);
        v.loadingData = false
        v.$swal.fire({
          icon: 'error',
          title: 'Have some problem here!',
          text: 'Invalid address. Please input exact token address!',
        })
      }
    },

    async fetchContractInfo() {
      const chainId = await this.walletClient.web3Client.eth.net.getId()
      this.$set(this, 'chainId', chainId)
      console.log('chainId', chainId)

      const result = await getContractInfo(this.walletClient.web3Client)
      this.$set(this, 'contractInfo', result)

    },
    async fetchCurrentDogeKongZillaBalance() {
      const result = await getDogeKongZillaBalance(this.walletClient.web3Client)
      this.$set(this, 'dkzBalance', result)
      this.$store.dispatch('app/dkzBalance', result)
    },
    async fetchBNBPrice() {
      let priceFeedData = this.priceFeedData

      if (this.latestPriceFeed + 3600000 < new Date().getTime()) {
        const response = await fetch('https://min-api.cryptocompare.com/data/pricemultifull?fsyms=BNB&tsyms=USD')
        priceFeedData = await response.json()
        this.latestPriceFeed = new Date().getTime()
      }

      this.$set(this, 'priceFeedData', priceFeedData)
    },
    async fetchStatus() {
      this.fetchContractInfo()
      this.fetchBNBPrice()
      this.fetchCurrentDogeKongZillaBalance()
    },
    intervalFetchStatus() {
      setInterval(() => {
        this.fetchStatus()
      }, 5000)
    }
  },
  mounted() {

    const v = this
    this.$on('fetchStatus', () => {
      v.loadingData = true
      v.fetchStatus()

      setTimeout(() => {
        this.intervalFetchStatus()
        v.loadingData = false
      }, 2000)
    })
  },
};
</script>
